import { render, staticRenderFns } from "./CheckoutSelectPatient.vue?vue&type=template&id=313b8f28&"
import script from "./CheckoutSelectPatient.vue?vue&type=script&lang=js&"
export * from "./CheckoutSelectPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports